<!--
  Rendered only while open, so the projected body is torn down with the panel rather
  than kept alive off-screen behind a zero width -- which is what the hand-rolled
  panel this replaces used to do.
-->
<ng-container *ngIf="open">

  <div class="tdp-scrim" [class.tdp-scrim--elevated]="elevated" (click)="close()"></div>

  <aside class="tdp-panel" [class.tdp-panel--elevated]="elevated"
         role="dialog" [attr.aria-label]="label">

    <button type="button" class="tdp-close" title="Close" aria-label="Close" (click)="close()">&times;</button>

    <div class="tdp-body">
      <ng-content></ng-content>
    </div>

    <footer class="tdp-foot" *ngIf="showFooter">
      <ng-content select="[panelFooter]"></ng-content>
    </footer>

  </aside>
</ng-container>
